import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { uploadObject } from '../../rest/data';
import { Abbreviation, copyRestObject, Language } from '../../rest/models';
import { Valid, RequestStatusDisplay } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { useState } from 'react';
import { RequestStatus } from '../../api_request/api_request';
import { getModelArr } from '../../rest/slice';

export function AbbreviationEditForm(props: Props)
{
    const appDispatch = useAppDispatch();
    const l = props.lang;

    function copyAbbr(a?: Abbreviation)
    {
        const ret = copyRestObject(a ?? new Abbreviation(), Abbreviation);
        ret.language = l.key;

        return ret;
    }

    //The abbreviation as it is in the editor form.
    const [a, setA] = useState(copyAbbr(props.abbr));

    //Keeps track of what's happening with the request.
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);
    
    const isDuplicate = (getModelArr(useAppSelector, Abbreviation) ?? [])
        .filter(a2 => a.text === a2.text) //Objects with the same properties as the current form.
        .some(a2 => a.key !== a2.key); //Unless it's the same object that we're editing. It can equal itself.

    const forAllField =
        <td>
            <Input
                type='checkbox'
                checked={a.public}
                onChange={(e) => {a.public = e.currentTarget.checked; setA({...a});}} />
        </td>;

    const textInput = 
        <Input
            type='text'
            value={a.text}
            maxLength={100}
            onChange={(e) => {a.text = e.currentTarget.value; setA({...a});}} />;
    
    const submitButton = 
        <Button
            onClick={async function()
            {
                if (isDuplicate)
                {
                    window.alert('This abbreviation has the same text and language as another one.');
                    return;
                }

                const status = await uploadObject(a, Abbreviation, appDispatch, setRequest);
                if (status.success)
                {
                    setA(copyAbbr());
                    props.onDone();
                }
            }}>Submit</Button>;

    const form = 
        <div>
            <table border={1}>
                <tbody>
                    <tr>
                        <td><b>Text</b></td>
                        <td>
                            {textInput}
                            <Valid bValid={a.text.trim() || !a.id} children='Abbreviations must have text.'/>
                        </td>
                    </tr>
                    <tr>
                        <th>Public (admin function)</th>
                        {forAllField}
                    </tr>
                </tbody>
            </table>
            
            {submitButton}
            {a.id ? <Button onClick={(e) => props.onDone()}>Hide</Button> : <></>}
        </div>;

    const createOrEdit = a.id ? 'Edit' : 'Create';
    return (
        <div className={`ernots_${createOrEdit}ModelForm`}>
            {form}
            <RequestStatusDisplay request={request}/>
        </div>);
}

interface Props
{
    abbr?: Abbreviation;
    lang: Language;
    onDone: () => void;
}